import Router from 'next/router';

import {
  SessionStorage,
  SessionStorageDefaultValue,
} from '@shared/v2/constants/storage';

import { QP_QUOTES_PARAMS } from '@/constants';

const goToCheckout = ({
  propertyId,
  offerId,
  roomTypeId,
  flights,
  baggages,
  countryCode,
  travelType,
  hidePerPersonPrice,
  destinationName,
  searchQuery,
}) => {
  sessionStorage.setItem(
    SessionStorage.CHECKOUT_FORM_DATA,
    JSON.stringify(SessionStorageDefaultValue.CHECKOUT_FORM_DATA),
  );
  sessionStorage.setItem(
    SessionStorage.CHECKOUT_FORM_STEP,
    JSON.stringify(SessionStorageDefaultValue.CHECKOUT_FORM_STEP),
  );
  sessionStorage.setItem(
    QP_QUOTES_PARAMS,
    JSON.stringify({
      propertyId,
      offerId,
      roomTypeId,
      flights,
      baggages,
      countryCode,
      travelType,
      hidePerPersonPrice,
      destinationName,
      ...searchQuery,
    }),
  );

  return Router.push('/checkout').then(() => window.scroll(0, 0));
};

export default goToCheckout;
